// extracted by mini-css-extract-plugin
module.exports = {"home":"home_home__24Iel","logo":"home_logo__2dlOs","app-logo-spin":"home_app-logo-spin__jr7I3","link":"home_link__2fjj7"};